/**!
 * Created by Leonardo Cheslacki on 31/03/2025.
 *
 * MIT License
 *
 * Copyright (c) 2025 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import mainConfig from './../../../../config/main.config';

import WithType from './../WithType';

class StageGallery extends StageController {
    /**
     *
     * @param props
     * @param main
     * @returns {StageGallery}
     */
    constructor(props, main = {}) {
        super(props);

        // if (StageGallery._this instanceof StageGallery) {
        //     return StageGallery._this;
        // }

        this.props = props;
        this.main = main;

        this.state = {
            data: [] || {}
        };

        this.$window = null;

        this.$document = null;

        this.$galleryClass = null;

        this.$gallery_list = null;

        this.$gallery_arrow_left = null;

        this.$gallery_arrow_right = null;

        this.size10 = 10;
        this.size12 = 12;
        this.size20 = 20;
        this.size30 = 30;
        this.size45 = 45;
        this.size50 = 50;
        this.size100 = 80;

        StageGallery._this = this;
    };

    $functions = {
        handlePrev: function () {
            const _this = StageGallery._this;
            _this.$galleryClass.go('-1');
        },

        handleNext: function () {
            const _this = StageGallery._this;
            _this.$galleryClass.go('+1');
        },

        /**
         *
         * @param event
         * @param src
         */
        handleZoom: function (event, {src}) {
            const
                _this = StageGallery._this,
                {styles} = _this.props;

            const supportStyle = AllTap.$supportStyle();

            supportStyle.setStyle(styles.zoomFullscreen);

            supportStyle.create('zoom-full-screen');

            const app = document.getElementById('app');

            let
                zoom_background = document.createElement('DIV'),
                zoom_img = document.createElement('IMG'),
                zoom_close = document.createElement('IMG');

            const close = () => {
                _this.setAttributes(zoom_background, {class: 'zoom-background animate__animated animate__fadeOut'});
            };

            const animateEnd = ({animationName}) => {
                if (animationName === 'fadeOut') {
                    _this.removeListener('animationend', 'animationend-zoom', () => {
                        zoom_background.remove();
                    });
                    _this.removeListener('click', 'click-close-overlay-container', () => {
                        zoom_close.remove();
                    });

                    supportStyle.remove('zoom-full-screen');
                }
            };

            _this.setAttributes(zoom_background, {
                class: 'zoom-background animate__animated animate__fadeIn'
            });

            _this.setAttributes(zoom_img, {
                class: 'zoom-img',
                src: _this.getUriImage(src),
                alt: 'zoom-img'
            });

            _this.setAttributes(zoom_close, {
                id: 'close_overlay_container',
                width: `${this.size45}px`,
                height: `${this.size45}px`,
                alt: 'close',
                src: _this.getUriImage('close.png')
            });

            _this.removeListener('animationend', 'animationend-zoom', () => {
                _this.addListener(zoom_background, 'animationend', 'animationend-zoom', animateEnd);
            });

            _this.removeListener('click', 'click-close-overlay-container', () => {
                _this.addListener(zoom_close, 'click', 'click-close-overlay-container', close);
            });

            zoom_background.appendChild(zoom_img);

            zoom_background.appendChild(zoom_close);

            app.appendChild(zoom_background);
        }
    };

    /**
     *
     * @param property
     * @returns {*}
     */
    createElementGallery = (property) => {
        let
            _id = this.verifyField(property, 'attributes.id').value,
            value_src = this.verifyField(property, 'product.src.value'),
            value_text = this.verifyField(property, 'product.text.value'),
            value_warn = this.verifyField(property, 'product.warn.value'),
            value_description = this.verifyField(property, 'product.description.value'),
            attribute_allow = this.getNodeAttribute(property, 'allow');

        if (this.hasString(attribute_allow, 'gallery') && value_src) {
            const createButtonZoom = () => {
                let div = this.createElementHtml('div', {class: 'zoom-button'}, [
                    this.createElementHtml('img', {
                        class: 'zoom-icon',
                        alt: 'zoom-icon',
                        src: this.getUriImage('zoom.png'),
                        width: this.size30,
                        height: this.size30
                    })
                ]);

                this.removeListener('click', `click-zoom-${_id}`, () => {
                    this.addListener(div, 'click', `click-zoom-${_id}`, this.$functions.handleZoom, false, {
                        src: value_src
                    });
                });

                return div;
            };

            const createWater = () => {
                return this.createElementHtml('div', {class: 'water-mark'}, [
                    this.createElementHtml('img', {
                        class: 'water-icon',
                        alt: 'water-icon',
                        src: this.getUriImage('water.png')
                    })
                ]);
            };

            const createWarnNode = () => {
                //value_warn = `${value_warn.charAt(0).toUpperCase()}${value_warn.slice(1).toLowerCase()}`;
                return this.toCapitalize(value_warn);
            };

            const createDescriptionNode = () => {
                //value_description = `${value_description.charAt(0).toUpperCase()}${value_description.slice(1).toLowerCase()}`;
                return this.toCapitalize(value_description);
            };

            let
                li = this.createElementHtml('li', {class: 'splide__slide'}, null, this.$document),
                figure = this.createElementHtml('figure', {class: 'splide__slide__container'}, [
                    this.createElementHtml('img', {
                        src: this.getUriImage(value_src),
                        alt: (value_text ? this.toSlug(value_text.toLowerCase()) : 'image')
                    })
                ]);

            let
                zoom = createButtonZoom(),
                water = createWater();

            figure.appendChild(zoom);

            figure.appendChild(water);

            value_text && figure.appendChild(this.createElementHtml('figcaption', {class: 'legend font-legend'}, value_text));

            value_warn && figure.appendChild(this.createElementHtml('p', {class: 'legend-p legend-p-left'}, createWarnNode()));

            value_description && figure.appendChild(this.createElementHtml('p', {class: 'legend-p legend-p-right'}, createDescriptionNode()));

            li.appendChild(figure);

            return li;
        }
    };

    startGallery = () => {
        const {data} = this.state;

        for (let property of data) {
            let element = this.createElementGallery(property);
            element && this.$gallery_list.appendChild(element);
        }
    };

    /**
     *
     * @returns {*}
     */
    createOverlayContainer = () => {
        const {buttons} = this.props;

        /**
         *
         * @param object
         * @returns {null|*[]}
         */
        const createElementSvg = (object) => {
            let content = this.verifyField(object, 'content');

            const execute = (content) => {
                let elements = [];
                for (let property of content) {
                    let
                        key = this.keyObject(property),
                        element = this.createElementSVG(key, property[key].attributes, (() => {

                            let content = this.verifyField(property[key], 'content');

                            if (content) {
                                return execute(content);
                            } else {
                                return null;
                            }
                        })());

                    elements.push(element);
                }
                return elements;
            };

            if (this.isArrayIf(content)) {
                return execute(content);
            } else {
                return null;
            }
        };

        this.$gallery_list = this.createElementHtml('ul', {
            id: 'gallery_list',
            class: 'splide__list'
        }, null, this.$document);

        this.$gallery_arrow_left = this.createElementHtml('div', {
            id: 'gallery_arrow_left',
            class: 'gallery-arrow-left'
        }, [
            this.createElementSVG('svg', buttons.svgLeft.attributes, createElementSvg(buttons.svgLeft))
        ]);

        this.$gallery_arrow_right = this.createElementHtml('div', {
            id: 'gallery_arrow_right',
            class: 'gallery-arrow-right'
        }, [
            this.createElementSVG('svg', buttons.svgRight.attributes, createElementSvg(buttons.svgRight))
        ]);

        return this.createElementHtml('div', {id: 'gallery_overlay_container', class: 'splide'}, [
            this.createElementHtml('div', {id: 'track', class: 'splide__track'}, [this.$gallery_list]),
            this.$gallery_arrow_left,
            this.$gallery_arrow_right
        ]);
    };

    mainGallery = () => {
        let composition = this.getComposition(this.props.current_name);
        this.isEmpty(composition) && (composition = this.getComposition(this.props.current_page));

        const
            {properties} = composition.getLibrary(),
            widthOriginal = properties.width,
            widthCurrent = stage.canvas.clientWidth,
            {xml, path, options, styles} = this.props,
            {stage: {canvas}} = this.get();

        this.$window = canvas.ownerDocument.defaultView;

        this.$document = canvas.ownerDocument;

        const supportStyle = AllTap.$supportStyle();

        this.size10 = this.calcSize(widthOriginal, widthCurrent, 10, false, 'int');
        this.size12 = this.calcSize(widthOriginal, widthCurrent, 12, false, 'int');
        this.size20 = this.calcSize(widthOriginal, widthCurrent, 20, false, 'int');
        this.size30 = this.calcSize(widthOriginal, widthCurrent, 30, false, 'int');
        this.size45 = this.calcSize(widthOriginal, widthCurrent, 45, false, 'int');
        this.size50 = this.calcSize(widthOriginal, widthCurrent, 50, false, 'int');
        this.size100 = this.calcSize(widthOriginal, widthCurrent, 80, false, 'int');

        supportStyle.setStyle({
            ...styles.zoomButton,
            galleryArrowLeft: {
                left: `${this.size20}px`,
            },
            galleryArrowRight: {
                right: `${this.size20}px`,
            },
            galleryArrowIcon: {
                width: `${this.size50}px`,
            },
            waterIcon: {
                width: `${this.size100}px`,
            },
            waterMark: {
                position: 'absolute',
                top: `${this.size30}px`,
                left: `${this.size30}px`
            },
            zoomIcon: {
                width: `${this.size30}px`,
                height: `${this.size30}px`
            },
            zoomButton: {
                cursor: 'pointer',
                position: 'absolute',
                bottom: `-${this.size45}px`,
                right: `-${this.size45}px`,
                padding: `${this.size10}px`
            },
            fontLegend: {
                fontSize: `${this.size12}px`
            }
        });

        supportStyle.create('gallery-slider', this.$document);

        let element = this.createOverlayContainer();

        this.$document.getElementById('animation_container').appendChild(element);

        AllTap.on('animate_gallery_complete', () => {
            this.$galleryClass = (new this.$window.Splide(element, options));

            this.$galleryClass.mount();
        });

        AllTap.on('animate_gallery_end', () => {
            this.$galleryClass.destroy();

            this.$galleryClass = null;
        });

        this.getForm(`${this.$base_uri}/${path.uri_xml}/${xml}`, {}, {
            done: (response) => {
                let
                    object = this.firstArray(this.xmlToJson(response)),
                    products = this.getObject(object, 'products');

                this.setState({...this.state, data: products}, this.startGallery);
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.removeListener('click', 'click-prev-gallery', () => {
                    this.addListener(this.$gallery_arrow_left, 'click', 'click-prev-gallery', this.$functions.handlePrev);
                });

                this.removeListener('click', 'click-next-gallery', () => {
                    this.addListener(this.$gallery_arrow_right, 'click', 'click-next-gallery', this.$functions.handleNext);
                });
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StageGallery.propTypes = {
    current_name: PropTypes.string,
    xml: PropTypes.string,
    path: PropTypes.object,
    options: PropTypes.object,
    styles: PropTypes.object,
    buttons: PropTypes.object
};

/**
 *
 * @type {{}}
 */
StageGallery.defaultProps = {
    current_name: null,
    xml: 'galley.xml',
    path: mainConfig.path,
    options: mainConfig.gallery.options,
    styles: mainConfig.gallery.styles,
    buttons: mainConfig.gallery.buttons
};

/**
 *
 * @type {{}}
 * @private
 */
StageGallery._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageGallery, {className: 'StageGallery'});
